export default function LoggerPlugin(Vue, { logger }) {
  Vue.prototype.$logger = logger;
}
